import React, {Component, useLayoutEffect} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import {Link} from 'react-router-dom';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {Tab, Tabs} from "react-bootstrap";
import * as moment from "moment";
import DatePicker from "react-datepicker";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
var yesterday = new Date(Date.now() + 0 * 40 * 60 * 1000);

var yestSend = moment(yesterday).format('YYYY-MM-DD');

class OrderPlacement extends Component {
    constructor(props) {
        super(props);
        this.state = {
           requestDate:yestSend,
            paymentDate:yestSend,
            loading:false,
            ProductName:'',
            QTY:'',
            PaymentAmount:'',
            imageData:'',
            productLis:[],
            TranRefNo:'',
            ModeOfPay:''

        }
    }

    componentDidMount() {

        axios.get(config.get('API_URL') + '/inventory/getProductList', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`,
                SalesforceToken: ` ${localStorage.salesforce_token}`
            }
        }).then(response => {
            this.setState({
                productLis: response.data
            })
            console.log(this.state.productLis);
        })
            .catch(err=>{
                console.log(err);
            })




        const token = localStorage.usertoken;
        try {
            const decoded = jwt_decode(token);

            console.log(decoded.userGroupName);
            // this.setState({
            //     userName: decoded.firstName + ' ' + decoded.lastName,
            //     user_type: decoded.userGroupName,
            // });

        } catch (err) {
            console.log("expired check failed!");
        }

    }

    OnProductChangeChange(e) {

        if (e.target.value === "Select...") {
            return false;
        }

        var index = e.target.selectedIndex;
        var txt = e.target[index].text;
        var val =e.target[index].value;

        this.setState({
            ProductName:val
        })

    }

    OnQuantityChange(e){
        var qty= e.target.value;
        if (isNaN(qty)) {
            return;
        }
        else{
            if(qty>0) {
                this.setState({
                    QTY: qty
                })
            }
            else
            {
                this.setState({
                    QTY: ''
                })
            }
        }
    }

    onPaymentAmountChange(e){

        var Amount= e.target.value;
        if (isNaN(Amount)) {
            return;
        }
        else{

                this.setState({
                    PaymentAmount: Amount
                })
        }
    }

    onTRNChange(e){

        var Amount= e.target.value;
        this.setState({
            TranRefNo: Amount
        })
        // if (isNaN(Amount)) {
        //     return;
        // }
        // else{
        // }
    }

    OnModePayChange(e) {

        if (e.target.value === "Select...") {
            return false;
        }

        var index = e.target.selectedIndex;
        var val =e.target[index].value;

        this.setState({
            ModeOfPay:val
        })

    }

    handleFromChange = date => { //alert(date);
        var date_filter = moment(date).format('YYYY-MM-DD');
        this.setState({
            paymentDate: date_filter
        });
    };

    _onChange(){
        const preview = document.querySelector('img');
        var fileReader = new FileReader();
        fileReader.onload = function () {
          document.getElementById('imgView').src=fileReader.result;
           // var data= fileReader.result;// data <-- in this var you have the file data in Base64 format

        };
    fileReader.readAsDataURL($('#imgUpload').prop('files')[0]);


    }


   async onPlaceOrderClick(){



        if(this.state.ProductName ==='' || this.state.ProductName ==='Select...')
        {
            this.props.handleClick("tr", 3, "Select product name.");
            return;
        }

        if(this.state.QTY <=0){
            this.props.handleClick("tr", 3, "Enter Quantity");
            return;
        }

        if(this.state.PaymentAmount ===''){
            this.props.handleClick("tr", 3, "Enter Amount");
            return;
        }

       if(this.state.TranRefNo ===''){
           this.props.handleClick("tr", 3, "Enter Transaction Reference Number ");
           return;
       }

       if(this.state.ModeOfPay ==='' || this.state.ModeOfPay ==='Select...')
       {
           this.props.handleClick("tr", 3, "Select Mode of Payment.");
           return;
       }

        var imagedata = document.getElementById('imgView').src;

        document.getElementById("OrderPlacementSubmit").disabled = true;

        const token = localStorage.usertoken;
        let warehouse_id = '';
        if (token != null) {
            const decoded = jwt_decode(token);
            warehouse_id = decoded.warehouse_id
        }

        var tempData={
            Distributor__c:warehouse_id,
            Request_date__c: this.state.paymentDate,
            Payment_Amount__c: this.state.PaymentAmount,
            Payment_Date__c:  this.state.paymentDate,
            Payment_Details__c: '',
            Product_Name__c: this.state.ProductName,
            Quantity__c: this.state.QTY,
            Transaction_reference_Number__c:this.state.TranRefNo,
            Mode_of_Payment__c:this.state.ModeOfPay
        }

        var chMsg=';'
        await axios.post(config.get('API_URL') + '/inventory/OrderPlacementForm',tempData, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`,
                SalesforceToken: ` ${localStorage.salesforce_token}`
            },
        }).then(response => {
            if(response.data==="Success")
            {
                chMsg="Success";
                this.props.handleClick("tr", 1, "Record has been saved successfully.");
            }
        })
        .catch((err)=>{
            console.log('Error');
            console.log(err);
        });

        if(chMsg==='Success') {
            setTimeout(function () {
                window.location.href = "/admin/orders";
            }.bind(this), 3000);

        }
}

    render() {

       let bindProductList= this.state.productLis.map((data)=>{
           return(
           <option value={data.Id}>{data.Description__c}</option>
           )
       })


        return (
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style}/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div>
                                <div className="col-mid-12 no-padd">
                                    <div className="card title-card-bottom-space">
                                        <div className="header">
                                            <h4 className="title">Order Placement Form</h4>
                                            <p className="category"></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="clearfix"></div>
                                    <React.Fragment>
                                        <div className=" content bgcolor">
                                            <div className=" container-fluid ">

                                                <div className="p-10">

                                                    <div className="">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="col-md-8">
                                                                    <div className="col-md-3">
                                                                        <label> Product Name:</label>
                                                                    </div>
                                                                    <div className="col-md-5">
                                                                        <select id="ProductName" name="ProductName" className="form-control"
                                                                                onChange={(e) => this.OnProductChangeChange(e)}>
                                                                            <option value="Select...">Select...</option>
                                                                            {bindProductList}
                                                                        </select>
                                                                    </div>
                                                                    <div className="clearfix"></div>
                                                                    <div className="gap_ver"></div>
                                                                    <div className="col-md-3">
                                                                        <label> Request Date: </label>
                                                                    </div>

                                                                    <div className="col-md-5">
                                                                        <label>  { moment(this.state.requestDate).format('DD-MM-YYYY')} </label>
                                                                    </div>
                                                                    <div className="clearfix"></div>
                                                                    <div className="gap_ver"></div>
                                                                    <div className="col-md-3">
                                                                        <label> Quantity: </label>
                                                                    </div>
                                                                    <div className="col-md-5">
                                                                        <input name="QTY" className="form-control"  value={this.state.QTY} onChange={this.OnQuantityChange.bind(this)} />
                                                                    </div>
                                                                    <div className="clearfix"></div>
                                                                    <div className="gap_ver"></div>
                                                                    <div className="col-md-3">
                                                                        <label>Payment Amount:</label>
                                                                    </div>
                                                                    <div className="col-md-5">
                                                                        <input name="PaymentAmount" className="form-control " value={this.state.PaymentAmount} onChange={this.onPaymentAmountChange.bind(this)} />
                                                                    </div>
                                                                    <div className="clearfix"></div>
                                                                    <div className="gap_ver"></div>
                                                                    <div className="col-md-3">
                                                                        <label> Payment Date:</label>
                                                                    </div>
                                                                    <div className="col-md-5">
                                                                        <DatePicker
                                                                            dateFormat="dd-MM-yyyy"
                                                                            selected={Date.parse(this.state.paymentDate)}
                                                                            onChange={this.handleFromChange}
                                                                            maxDate={new Date()}
                                                                        />
                                                                    </div>
                                                                    <div className="clearfix"></div>
                                                                    <div className="gap_ver"></div>
                                                                    <div className="col-md-3">
                                                                        <label>Transaction reference Number:</label>
                                                                    </div>
                                                                    <div className="col-md-5">
                                                                        <input name="TRN" className="form-control " value={this.state.TranRefNo} onChange={this.onTRNChange.bind(this)} />
                                                                    </div>
                                                                    <div className="clearfix"></div>
                                                                    <div className="gap_ver"></div>
                                                                    <div className="col-md-3">
                                                                        <label> Mode of Payment:</label>
                                                                    </div>
                                                                    <div className="col-md-5">
                                                                        <select id="ModeOfPay" name="ProductName" className="form-control"
                                                                                onChange={(e) => this.OnModePayChange(e)}>
                                                                            <option value="Select...">Select...</option>
                                                                            <option value="NEFT">NEFT</option>
                                                                            <option value="RTGS">RTGS</option>
                                                                            <option value="IMPS">IMPS</option>
                                                                            <option value="Others">Others</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className="clearfix"></div>
                                                                    <div className="gap_ver"></div>
                                                                    <div className="col-md-3">
                                                                        <label>Attached Payment Details:</label>
                                                                    </div>
                                                                    <div className="col-md-5">
                                                                        <input id="imgUpload" type="file" onChange={this._onChange.bind(this)} />

                                                                    </div>
                                                                    <div className="clearfix"></div>
                                                                    <div className="gap_ver"></div>
                                                                    <div className="col-md-12 invetoryTextCenter">
                                                                        <hr />
                                                                        <button type="button" id="OrderPlacementSubmit" className="btn btn-primary"  onClick={this.onPlaceOrderClick.bind(this)} >Submit
                                                                        </button>
                                                                        {' '}

                                                                        {/*<button type="button" className="btn btn-secondary"  >Cancel </button>*/}
                                                                        {/*onClick={this.onDisSubmit.bind(this)}*/}
                                                                    </div>

                                                                </div>

                                                                <div className="col-md-4 " >
                                                                    <img id="imgView" src="" width="100%" alt="Image preview..." />
                                                                </div>
                                                        </div>
                                                        <div className="">

                                                            <div className="clearfix"></div>
                                                            <div className="gap_ver"></div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        </div>

                                    </React.Fragment>

                                <div className="footer">
                                    <div className="stats"><i></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderPlacement;